import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getDenominationReport = ({ denominationId, reportId }) => {
  return axios.get(`/denominations/${denominationId}/report/${reportId}`);
};

export const useDenominationReport = ({
  denominationId,
  reportId,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["denomination-report", denominationId, reportId],
    queryFn: () => getDenominationReport({ denominationId, reportId })
  });
};
